import React from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import Col from 'react-bootstrap/Col';
import properties from '../../../modules/ajio-util/properties';
import { hideModal } from '../../../actions/modal';
import ProductSizeUpdation from './ProductSizeUpdation';

import { sendEvent } from '../../../utils/dataGrinch.js';
import { getPageInfo } from '../../../utils/pageInfo.js';
import { calculatePriceInfo } from '../../../utils/products.js';
import cleverTapPushEvent from '../../../modules/ajio-util/cleverTap/eventUtils';
import CLEVERTAP_EVENT_NAMES from '../../../modules/ajio-util/cleverTap/eventConstants';
import {
  getNewSizeRevampFlag,
  getShowBrandSizeFlag,
  getLuxeFlags
} from '../../../Flags/selectors.js';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import { getProductItemForCart, gtmEventPush, segmentEventPush } from '../../../modules/ga/GTMdatalayer';
import luxeScreen from '../../../refresh/constants/luxeScreenType';
import { readCookie } from '../../../components/common/Cookie';
// Desktop cart popup — uses the desktop SLA component. Deep imports keep the
// connected container (and its redux wiring) out of this bundle.
import DeliverySLA from '../../../components/desktop/DeliverySLA/DeliverySLA';
import {
  findDeliveryChoice,
  mapDeliveryChoice,
  deliveryChoicesToSizeVariants,
  sizeVariantSelectedOf
} from '../../../components/desktop/DeliverySLA/mapDeliveryChoices';
// Wishlist renders the connected desktop PDP container, so the SLA block is
// driven by exactly the same store reads and mapping the PDP uses.
import DeliverySLAContainer from '../../../components/desktop/DeliverySLA/DeliverySLAContainer';
import { getDeliveryChoices } from '../../actions/cart';
// Aliased: `selectSize` is already a state key in this component's render.
import { selectSize as selectPdpSizeAction } from '../../../actions/productData';
import {
  getMultiSellerSlaFlag,
  getMultiSellerSlaConfig
} from '../../../refresh/selectors/featureFlagsSelector';
import { pickSlaDeliveryNote } from '../../../refresh/molecules/DeliverySLA/constants';
import { selectSlaOptions } from '../../../components/desktop/DeliverySLA/selectSla';

const INFO_ICON = `${properties.getProperty('imageBaseUrl')}/static/img/multiseller-info-icon.svg`;
const INFO_ICON_LUXE = `${properties.getProperty(
  'imageBaseUrl'
)}/static/img/multiseller-info-icon-luxe.svg`;

// Same copy used when Amplitude omits oneSlaDeliveryNote.
const SLA_DELIVERY_NOTE = 'Delivery time may vary based on items in your bag';

/**
 * availableQuantity of the delivery card in play — the one the user picked in
 * this popup, else the API's preselected card, else the first serviceable one.
 * Returns undefined when there are no options (or no numeric quantity), so the
 * caller keeps the size-level stock it already had.
 */
const slaStockLevelOf = (viewModel, userRawPriceType) => {
  const options = viewModel?.options || [];
  if (!options.length) return undefined;
  const picked =
    (userRawPriceType && options.find(option => option?.rawPriceType === userRawPriceType)) ||
    options.find(option => option?.isSelected && option?.serviceable) ||
    options.find(option => option?.serviceable) ||
    options[0];
  const level = Number(picked?.stock?.level);
  return Number.isFinite(level) ? level : undefined;
};

/**
 * Point `isSelected` at the option the user picked in this popup.
 *
 * The cart maps its view model inline on every render, so each render hands
 * DeliverySLA a different object — and that component scopes a manual pick to
 * the exact view model it was made on, deliberately, so a fresh scopedView
 * response wins. Selecting a card here calls setState, which re-renders and
 * remaps, so the pick was dropped every time and the radio jumped back to the
 * API's choice. Folding the pick into the model keeps the model the single
 * source of truth for what is selected.
 *
 * Left alone when the picked priceType is not among this size's serviceable
 * options — after a size change the API's own selection should stand.
 */
const withUserSlaSelection = (viewModel, userRawPriceType) => {
  if (!viewModel || !userRawPriceType) return viewModel;
  const options = viewModel.options || [];
  const picked = options.find(
    option => option?.rawPriceType === userRawPriceType && option?.serviceable
  );
  if (!picked) return viewModel;
  return {
    ...viewModel,
    options: options.map(option => ({
      ...option,
      isSelected: option === picked
    }))
  };
};

const { cart: { screenType = '', screenName = '' } = {}, luxeStore = '' } = luxeScreen;
class ProductUpdationPopup extends React.Component {
  constructor(props) {
    super(props);
    this.config = {
      min: 1,
      max: 10
    };
    this.state = {
      currentCount: 0,
      oldQuantity: 0,
      selectSize: false,
      // Cart-side delivery options. The wishlist host fetches them itself and
      // passes them in, so this stays empty there.
      cartDeliveryChoices: [],
      cartChoicesLoading: false,
      cartChoicesError: false,
      // Multiseller: user's SLA pick in the modal (overrides API isSelected).
      userPriceType: '',
      slaSelectedPriceType: '',
      // Intentional edits only — auto qty reset on size/seller is not a qty edit.
      userChangedSize: false,
      userChangedQty: false,
      userChangedSeller: false
    };
    this.handleSlaSelect = this.handleSlaSelect.bind(this);
    this.textContent = {
      selectQuantity: 'Select quantity'
    };
  }

  componentWillMount() {
    const { quantity = 0, newDesignLuxe, itemData, wishlistPage = false } = this.props;

    this.setState({ currentCount: quantity, oldQuantity: quantity });
    // The events below describe a cart line-item being edited. The wishlist host
    // opens the same popup to add a brand new item, so they are skipped there —
    // that flow pushes its own closet events (see wishlistAddToBag).
    if (wishlistPage) return;
    if (newDesignLuxe) {
      gtmEventPush({
        event: 'size_change_cart',
        event_category: 'bag interactions',
        event_action: 'size change',
        store_type: 'luxe',
        screen_name: screenName,
        screen_type: screenType
      });
    }

    segmentEventPush({
       event: 'Size Updated',       
       screen_name: screenName,
       screen_type: screenType,
       cart_id: readCookie('C'),
       products:[
        {
          ...getProductItemForCart(itemData)
        }
       ]

    })

  }

  componentDidMount() {
    this.fetchDeliveryChoicesIfNeeded();
    this.syncWishlistSizeToPdpState();
  }

  componentDidUpdate(prevProps) {
    const { size = '' } = this.props;
    if (size !== (prevProps.size || '')) {
      this.syncWishlistSizeToPdpState();
    }
  }

  /**
   * Wishlist SLA — driven exactly like the PDP.
   *
   * The size list writes the picked sku to `cart.size`; mirroring it into the
   * product slice through the PDP's own `selectSize` gives the SLA block the
   * same inputs it has on the PDP: `product.selectedSizeCode` is set and
   * `selectSize` fires the scopedView (v2) call for that sku. DeliverySLAContainer
   * then reads the response out of the store on its own.
   */
  syncWishlistSizeToPdpState = () => {
    const {
      wishlistPage = false,
      multiSellerSlaEnabled,
      size = '',
      sizeOptions = [],
      selectPdpSize,
      itemData = {}
    } = this.props;
    if (!wishlistPage || !multiSellerSlaEnabled || !size || !selectPdpSize) return;
    const { value: sizeLabel = '' } = sizeOptions.find(({ code }) => code === size) || {};
    // scopedView needs this product's option code. `selectSize` would otherwise
    // read it off product.productDetails, which here holds whatever PDP was last
    // visited (or nothing) — so hand it the wishlist entity's own code.
    selectPdpSize(sizeLabel, size, itemData?.code || '');
  };

  /**
   * Pull the delivery options for this cart line.
   *
   * deliveryChoices returns every size of the option in one payload, so a single
   * call on open covers the size the user is about to pick — no refetch per size
   * and no checkDeliveryDetails call from the cart.
   */
  fetchDeliveryChoicesIfNeeded = () => {
    const {
      multiSellerSlaEnabled,
      code = '',
      fetchDeliveryChoices,
      wishlistPage = false
    } = this.props;
    // The wishlist path is on v2 (fetchWishlistSlaIfNeeded), not deliveryChoices.
    if (wishlistPage) return;
    if (!multiSellerSlaEnabled || !code || !fetchDeliveryChoices) return;

    this.setState({
      cartDeliveryChoices: [],
      cartChoicesLoading: true,
      cartChoicesError: false
    });
    fetchDeliveryChoices({ productId: code })
      .then((response = []) => {
        this.setState({
          cartDeliveryChoices: Array.isArray(response) ? response : [],
          cartChoicesLoading: false,
          cartChoicesError: false
        });
      })
      .catch(() => {
        this.setState({
          cartDeliveryChoices: [],
          cartChoicesLoading: false,
          cartChoicesError: true
        });
      });
  };

  setSelectedSizeValue = () => {
    const { multiSellerSlaEnabled, wishlistPage = false } = this.props;
    // Multiseller cart: size change resets qty to 1 (seller/SLA options are size-scoped).
    if (multiSellerSlaEnabled && !wishlistPage) {
      const qtyActuallyReset = Number(this.state.currentCount) > 1;
      this.setState({
        selectSize: true,
        currentCount: 1,
        userPriceType: '',
        userChangedSize: true,
        userChangedSeller: false,
        ...(qtyActuallyReset ? { userChangedQty: true } : {})
      });
      return;
    }
    this.setState({ selectSize: true, userChangedSize: true });
  };

  handleSlaSelect = option => {
    const { multiSellerSlaEnabled, wishlistPage = false } = this.props;
    if (!multiSellerSlaEnabled || wishlistPage) return;
    // Multiseller: switching SLA/seller option resets qty to 1.
    // Count as Quantity Update only when qty actually drops from >1 to 1.
    const qtyActuallyReset = Number(this.state.currentCount) > 1;
    this.setState({
      selectSize: true,
      currentCount: 1,
      userPriceType: option?.rawPriceType || '',
      userChangedSeller: true,
      ...(qtyActuallyReset ? { userChangedQty: true } : {})
    });
  };

  changeQuantity(changeType = 'decrement') {
    const { newDesignLuxe, code = '', itemData = {}, wishlistPage = false } = this.props;
    if (changeType === 'decrement' && this.state.currentCount - 1 > 0) {
      this.setState({ currentCount: this.state.currentCount - 1, userChangedQty: true });
    } else if (changeType === 'increment' && this.state.currentCount + 1 <= 10) {
      this.setState({ currentCount: this.state.currentCount + 1, userChangedQty: true });
    } else {
      return;
    }

    // Cart-only quantity events — nothing is in the bag yet on the wishlist.
    if (wishlistPage) return;
    if (newDesignLuxe) {
      gtmEventPush({
        event: 'quanity_change_cart',
        event_category: 'bag interactions',
        event_action: 'quantity change',
        event_label: changeType,
        store_type: luxeStore,
        screen_name: screenName,
        screen_type: screenType
      });
    }
    segmentEventPush({
      event: 'Product Quantity Updated',    
      order_id : readCookie('C'),
      //order_status
      //previous_screen_name
      product_id : code,
      screen_name: 'Cart Page',
      products: [
        {
          ...getProductItemForCart(itemData)
        }
      ]
    })
  }

  updateProductForDataGlinch = () => {
    const { code = '', size, priceInfo = {} } = this.props;

    const { Price, Discount } = calculatePriceInfo(priceInfo);

    const { currentCount } = this.state;

    const eventObj = [];

    eventObj.ProductId = code;
    eventObj.NewQuantity = currentCount;
    eventObj.NewSize = size;

    eventObj.Price = Price;
    eventObj.Discount = Discount;

    const { pageId, pageType } = getPageInfo(location.pathname || '');
    eventObj.pageId = pageId;
    eventObj.pageType = pageType;
    sendEvent('ProductUpdate', eventObj);
    cleverTapPushEvent({
      eventName: CLEVERTAP_EVENT_NAMES.Change_Quantity,
      eventObj: {
        New_Quantity: currentCount
      }
    });
  };

  handleSlaSelect(option = {}) {
    this.setState({ slaSelectedPriceType: option?.rawPriceType || '' });
  }

  render() {
    const {
      quantity = 0,
      entryNumber = -1,
      code = '',
      modalName = '',
      size,
      sizeDetails = [],
      dealEnabled = false,
      newSizeRevampFlag,
      showBrandSizeFlag,
      beautyVolume = '',
      hideSizes = false,
      newDesignLuxe,
      itemData = {},
      multiSellerSlaEnabled = false,
      slaSkuId = '',
      slaConfig = {},
      slaCodeLabels,
      wishlistPage = false,
      variantOptions = [],
      sizeOptions = [],
      wishlistSlaOptions = [],
      selectedSlaOption = null,
      activePincode = '',
      hasCartDeliveryLocation = false
    } = this.props;
    const {
      selectSize,
      currentCount,
      oldQuantity,
      cartDeliveryChoices,
      cartChoicesLoading,
      cartChoicesError,
      userPriceType,
      slaSelectedPriceType,
      userChangedSize,
      userChangedQty,
      userChangedSeller
    } = this.state;
    // Keys as defined on multiSellerSlaConfig — note depends on SLA card count.
    const { priceTypeTags } = slaConfig;

    // Cart reads the deliveryChoices payload it pulls on open — one call per
    // option covering every size — so changing size only re-reads what is in
    // hand. The wishlist renders the connected PDP container instead (see below),
    // which owns its own store reads.
    const selectedSkuId = slaSkuId;
    const { value: selectedSizeLabel } =
      sizeOptions.find(({ code: sizeCode }) => sizeCode === selectedSkuId) || {};
    const slaViewModel = withUserSlaSelection(
      multiSellerSlaEnabled && !wishlistPage && selectedSkuId
        ? mapDeliveryChoice(
            findDeliveryChoice(cartDeliveryChoices, selectedSkuId, selectedSizeLabel),
            priceTypeTags
          )
        : null,
      userPriceType
    );
    const showSla = Boolean(
      hasCartDeliveryLocation &&
        slaViewModel &&
        (cartChoicesLoading || cartChoicesError || slaViewModel.options.length > 0)
    );
    // Wishlist: the PDP container renders (and self-gates on) the SLA for the
    // sku in `product.selectedSizeCode`, which syncWishlistSizeToPdpState sets.
    const showWishlistSla = Boolean(wishlistPage && multiSellerSlaEnabled);
    // Cart only — the wishlist takes its note from DeliverySLAContainer (below),
    // which owns the mapping that decides how many cards actually render.
    const deliveryNote =
      pickSlaDeliveryNote(slaConfig, slaViewModel?.options?.length || 0) || SLA_DELIVERY_NOTE;
    let disableUpdateButton = true;

    // A different seller option (SLA) picked in the modal also counts as a change.
    const slaChanged =
      Boolean(slaSelectedPriceType) &&
      slaSelectedPriceType !== (itemData?.selectedPriceType || '');

    // Nothing is preselected on the wishlist, so a size is always required
    // before the item can go into the bag — a quantity bump alone is not enough.
    if (wishlistPage ? selectSize : selectSize || currentCount !== oldQuantity || slaChanged) {
      disableUpdateButton = false;
    }

    /* Multiseller cart: sizes + stock come from deliveryChoices, not sizeVariants
     * (that call is skipped). Reshaped into the sizeVariants baseOptions shape so
     * the swatch/stock code below and ProductSizeUpdation stay untouched. */
    const useDeliveryChoiceSizes = multiSellerSlaEnabled && !wishlistPage;
    const effectiveSizeDetails = useDeliveryChoiceSizes
      ? {
          baseOptions: [
            {
              variantType: 'FnlSizeVariant',
              options: deliveryChoicesToSizeVariants(cartDeliveryChoices),
              selected: {
                variantOptionQualifiers:
                  sizeVariantSelectedOf(
                    findDeliveryChoice(cartDeliveryChoices, selectedSkuId, selectedSizeLabel)
                  )?.variantOptionQualifiers || []
              }
            }
          ]
        }
      : sizeDetails;

    let sizeVariantOptions = [];
    (effectiveSizeDetails.baseOptions || []).forEach((variant, i) => {
      if (variant.variantType === 'FnlSizeVariant') {
        sizeVariantOptions = variant.options;
      }
    });
    const productList = [];
    sizeVariantOptions.forEach(({ code, stock }) => {
      productList.push({ code, stock });
    });
    const [{ stock: { stockLevel: sizeStockLevel } = {} } = {}] = (productList || []).filter(
      ({ code: productCode }) => productCode === size
    );
    /* Multiseller cart: availableQuantity lives on each deliveryDetails entry, so
     * the stock shown ("n left"), the qty ceiling and the update button follow the
     * selected delivery card — not the size as a whole. Flag off / wishlist (v2)
     * path / no options: the size-level stock stands, as before. */
    const slaStockLevel = useDeliveryChoiceSizes
      ? slaStockLevelOf(slaViewModel, userPriceType)
      : undefined;
    const stockLevel = slaStockLevel === undefined ? sizeStockLevel : slaStockLevel;
    if (stockLevel < currentCount) {
      disableUpdateButton = true;
    }

    let isSelectedSizeIsOOS = false;
    if (sizeVariantOptions && sizeVariantOptions.length) {
      const cartStockCheck =
        sizeVariantOptions.find(({ code: sizeCode }) => sizeCode === size) || {};
      if (cartStockCheck && cartStockCheck.stock) {
        const { stockLevel: stock } = cartStockCheck.stock;
        if (stock === 0) {
          isSelectedSizeIsOOS = true;
        }
      }
    }

    let isProductIsOOS = false;
    if (sizeVariantOptions && sizeVariantOptions.length) {
      isProductIsOOS = sizeVariantOptions.every(({ stock: { stockLevel } }) => stockLevel === 0);
    }
    if (isProductIsOOS) {
      disableUpdateButton = true;
    }

    // The wishlist opens this popup through a portal on document.body, outside the
    // SIS layout div that carries `luxe-newdesign store-in-store`. Repeating both
    // classes here lets the luxe theme (button colour, fonts, swatches) apply the
    // same way it does inside the cart.
    const luxeThemeClass = wishlistPage && newDesignLuxe ? 'luxe-newdesign store-in-store' : '';
    return (
      <div className={luxeThemeClass}>
        <div id="cardSizePopup">
          {/* Multiseller: deliveryChoices also decides which sizes are orderable.
              Passed empty on the wishlist (v2 path) and with the flag off, which
              leaves the swatches purely stock-driven. */}
          <ProductSizeUpdation
            code={code}
            setSelectedSizeValue={this.setSelectedSizeValue}
            size={size}
            sizeDetails={effectiveSizeDetails}
            variantOptions={variantOptions}
            newSizeRevampFlag={newSizeRevampFlag}
            showBrandSizeFlag={showBrandSizeFlag}
            hideSizes={beautyVolume || hideSizes}
            newDesignLuxe={newDesignLuxe}
            deliveryChoices={multiSellerSlaEnabled ? cartDeliveryChoices : []}
            enableMultiSellerSla={multiSellerSlaEnabled}
          />
        </div>
        <div id="cardQtyPopup">
          {/* Wishlist adds a single unit, so the quantity stepper is size-only there. */}
          {!wishlistPage &&
            (!dealEnabled ? (
              <div className="cartqty-section">
              <p className="header-label" role="heading" aria-level={2} id="quantity-group-label">
                {this.textContent.selectQuantity}
              </p>

            <div role="group" aria-labelledby="quantity-group-label">
              <button
                className={newDesignLuxe ? 'luxe-newdesign-decrement button' : 'decrement button'}
                onClick={() => this.changeQuantity('decrement')}
                disabled={isProductIsOOS || currentCount <= this.config.min}
                aria-label="Decrease quantity"
              >
                {' '}
                -{' '}
              </button>

              <div
                className={newDesignLuxe ? 'luxe-newdesign-counter' : 'counter'}
                role="status"
                aria-live="polite"
                aria-atomic="true"
              >
                {' '}
                {currentCount}{' '}
              </div>

              <button
                className={newDesignLuxe ? 'luxe-newdesign-increment button' : 'increment button'}
                onClick={() => this.changeQuantity('increment')}
                disabled={
                  isProductIsOOS ||
                  currentCount + 1 >
                    (stockLevel !== 'undefined'
                      ? Math.min(this.config.max, stockLevel)
                      : this.config.max)
                }
                aria-label="Increase quantity"
              >
                {' '}
                +{' '}
              </button>
            </div>
              {stockLevel !== undefined && stockLevel >= currentCount && stockLevel <= 10 && (
                <p className="available-error-msg">
                  <span className="availablily-message">{stockLevel} left </span>
                </p>
              )}
              {!!stockLevel && stockLevel < currentCount && (
                <p className="available-error-msg">
                  <span className="availablily-message">
                    Please update the quantity, only {stockLevel} left{' '}
                  </span>
                </p>
              )}
              {stockLevel !== undefined && stockLevel === 0 && !isSelectedSizeIsOOS && (
                <p className="available-error-msg">
                  <span className="availablily-message">This product is out of stock </span>
                </p>
              )}
            </div>
            ) : (
              <div className="dealSizeChangeMessage">Price may vary according to size</div>
            ))}
          {showSla && (
            <div className="cart-delivery-sla">
              <p className="cart-delivery-sla__heading" role="heading" aria-level={2}>
                Delivery Detail
                {deliveryNote && (
                  <span
                    className="cart-delivery-sla__info-wrap"
                    tabIndex={0}
                    role="button"
                    aria-label={deliveryNote}
                  >
                    <img
                      src={newDesignLuxe ? INFO_ICON_LUXE : INFO_ICON}
                      alt=""
                      aria-hidden="true"
                      className="cart-delivery-sla__info"
                    />
                    <span className="cart-delivery-sla__arrow" aria-hidden="true" />
                  </span>
                )}
                {/* Sibling of the icon, not a child: the bubble spans the
                    heading so it stays inside the modal instead of hanging
                    off the icon and spilling past the right edge. */}
                {deliveryNote && (
                  <span className="cart-delivery-sla__tooltip" role="tooltip">
                    {deliveryNote}
                  </span>
                )}
              </p>
              <DeliverySLA
                viewModel={slaViewModel}
                loading={cartChoicesLoading}
                error={cartChoicesError}
                slaCodeLabels={slaCodeLabels}
                hideHeader
                footerNote=""
                luxe={newDesignLuxe}
                onSelectOption={this.handleSlaSelect}
                perPiece
                activePincode={activePincode}
              />
            </div>
          )}
          {showWishlistSla && (
            <div className="cart-delivery-sla">
              {/* The heading rides along as `title` so it appears with the
                  response — not while the call is still in flight. Taking `note`
                  from the container ties the tooltip copy to the cards it just
                  rendered; deriving it here instead let the two disagree, since
                  mapSlaOptions dedupes by priceType and this component only sees
                  the raw options. */}
              <DeliverySLAContainer
                hideHeader
                luxe={newDesignLuxe}
                footerNote=""
                title={note => {
                  const wishlistNote = note || SLA_DELIVERY_NOTE;
                  return (
                    <p className="cart-delivery-sla__heading" role="heading" aria-level={2}>
                      Delivery Detail
                      {wishlistNote && (
                        <span
                          className="cart-delivery-sla__info-wrap"
                          tabIndex={0}
                          role="button"
                          aria-label={wishlistNote}
                        >
                          <img
                            src={newDesignLuxe ? INFO_ICON_LUXE : INFO_ICON}
                            alt=""
                            aria-hidden="true"
                            className="cart-delivery-sla__info"
                          />
                          <span className="cart-delivery-sla__arrow" aria-hidden="true" />
                        </span>
                      )}
                      {wishlistNote && (
                        <span className="cart-delivery-sla__tooltip" role="tooltip">
                          {wishlistNote}
                        </span>
                      )}
                    </p>
                  );
                }}
              />
            </div>
          )}
          {!isProductIsOOS ? (
            <button
              className="full-width-button"
              id="updateQuantity"
              disabled={disableUpdateButton}
              tabIndex={disableUpdateButton ? -1 : 0}
              onClick={() => {
                // Always the raw API priceType — never the normalized view-model
                // key, which collapses anything but BEST_SPEED/FASTEST to "best".
                const rawPriceTypeOf = option => option?.rawPriceType || option?.priceType || '';
                const cartSelectedPriceType =
                  userPriceType ||
                  slaSelectedPriceType ||
                  rawPriceTypeOf(
                    slaViewModel?.options?.find(option => option.isSelected && option.serviceable)
                  ) ||
                  rawPriceTypeOf(slaViewModel?.options?.find(option => option.serviceable)) ||
                  '';
                const wishlistSelectedPriceType =
                  selectedSlaOption?.priceType ||
                  (
                    wishlistSlaOptions.find(option => option?.isSelected) ||
                    wishlistSlaOptions[0] ||
                    {}
                  ).priceType ||
                  '';
                const selectedPriceType = wishlistPage
                  ? wishlistSelectedPriceType
                  : cartSelectedPriceType;
                const bagUpdateReasons = [];
                if (userChangedSize) bagUpdateReasons.push('Size Update');
                if (userChangedQty) bagUpdateReasons.push('Quantity Update');
                if (userChangedSeller) bagUpdateReasons.push('seller option update');
                const updateEntryObj = {
                  entryNumber,
                  newQty: currentCount,
                  code,
                  size: beautyVolume ? code : size,
                  itemData,
                  ...(multiSellerSlaEnabled && selectedPriceType
                    ? {
                        selectedPriceType,
                        ...(wishlistPage ? { slaOptions: wishlistSlaOptions } : {})
                      }
                    : {}),
                  bagUpdateReason: bagUpdateReasons.join(',')
                };
                const { updateQuantity } = this.props;
                if (wishlistPage) {
                  updateQuantity(modalName, updateEntryObj);
                  return;
                }
                updateQuantity(modalName, updateEntryObj)
                  .then(() => this.updateProductForDataGlinch(true))
                  .catch(() => this.updateProductForDataGlinch(false));
                ga('send', {
                  hitType: 'event',
                  eventCategory: 'Buttop tap',
                  eventAction: 'Current event for clicking on "update" button ',
                  eventLabel: 'Inventory change'
                });
              }}
            >
              {wishlistPage ? 'Add to Bag' : 'Update'}
            </button>
          ) : (
            <button
              className="full-width-button"
              id="updateQuantity"
              onClick={() => {
                window.location.reload();
              }}
            >
              OKAY
            </button>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps = {}) => {
  const { cart = {}, flags = {} } = state;
  const { size, sizeDetails } = cart;
  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  const slaConfig = getMultiSellerSlaConfig(state);
  // `cart.size` is only populated once the size list inside the popup mounts, so
  // it is empty on the first render of the quantity flow. The cart line already
  // knows its SKU, so use that until a different size is picked — otherwise the
  // SLA block never renders when the popup is opened from "Qty". Not applied on
  // the wishlist, where no size is selected yet and `code` is the base product.
  const { code: cartItemCode = '', wishlistPage = false } = ownProps;
  const slaSkuId = wishlistPage ? size : size || cartItemCode;
  // Same pincode the SLA slice is keyed by — the wishlist selects options with
  // it, and the cart cards name it in the "not deliverable" copy.
  const activePincode = state?.edd?.activePincode;
  // Somewhere to deliver to: a selected address, or failing that the bare
  // `pinCode` the cart response carries at its root. With neither there is
  // nothing to quote delivery against, so the SLA block stays hidden.
  // deliveryAddress is always present on the normalized cart and defaults to {},
  // hence the emptiness check rather than a plain existence one.
  const hasCartDeliveryLocation =
    Object.keys(state?.cart?.deliveryInfo?.deliveryAddress || {}).length > 0 ||
    Boolean(state?.cart?.pinCode);
  const wishlistSizeCode = state?.product?.selectedSizeCode || '';
  const wishlistSlaOptions = wishlistPage
    ? selectSlaOptions(state, activePincode, wishlistSizeCode)
    : [];
  return {
    newDesignLuxe,
    activePincode,
    hasCartDeliveryLocation,
    size,
    sizeDetails,
    newSizeRevampFlag: getNewSizeRevampFlag(flags),
    showBrandSizeFlag: getShowBrandSizeFlag(flags),
    multiSellerSlaEnabled: getMultiSellerSlaFlag(state),
    slaConfig,
    slaSkuId,
    wishlistSlaOptions,
    selectedSlaOption: state?.edd?.selectedSlaOption || null,
    // SLA copy lives on the multiseller flag alongside the rest of this feature's
    // config, so it covers every code the APIs emit rather than only the ones
    // priorityDeliverySLPTagsConfig happens to carry.
    slaCodeLabels: slaConfig?.slaTimeMessage
  };
};

const mapDispatchToProps = dispatch => {
  return {
    hideModal: name => {
      dispatch(hideModal(name));
    },
    fetchDeliveryChoices: payload => dispatch(getDeliveryChoices(payload)),
    // Same action the PDP size selector dispatches: it sets
    // product.selectedSizeCode and fires the scopedView (v2) call for that sku.
    selectPdpSize: (sizeName, sizeCode, optionCode = '') =>
      dispatch(
        selectPdpSizeAction(
          sizeName,
          sizeCode,
          undefined,
          undefined,
          undefined,
          undefined,
          optionCode
        )
      )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductUpdationPopup);
